export const categorys = [
  {
    id: 1,
    name: "All",
    slug: "/articles",
  },
  {
    id: 2,
    name: "Technology",
    slug: "/category/technology",
    path: "technology",
    image: "/category/technology.png",
  },
  {
    id: 3,
    name: "Programming",
    slug: "/category/programming",
    path: "programming",
    image: "/category/programming.jpg",
  },
  {
    id: 4,
    name: "Web Development",
    slug: "/category/webdevelopment",
    path: "webdevelopment",
    image: "/category/web-development-image.png",
  },
  {
    id: 5,
    name: "Software Engineering",
    slug: "/category/softwareengineering",
    path: "softwareengineering",
    image: "/category/Software Engineering.png",
  },
  {
    id: 6,
    name: "Software Q/A Testing",
    slug: "/category/softwaretesting",
    path: "softwaretesting",
    image: "/category/software_testing_qa.png",
  },
  {
    id: 7,
    name: "Machine Learning",
    slug: "/category/machinelearning",
    path: "machinelearning",
    image: "/category/machine learning.jpeg",
  },
  {
    id: 8,
    name: "Data Science",
    slug: "/category/datascience",
    path: "datascience",
    image: "/category/data-science.jpg",
  },
  {
    id: 9,
    name: "Artificial Intelligence",
    slug: "/category/ai",
    path: "ai",
    image: "/category/Artificial Intelligence.png",
  },
  {
    id: 10,
    name: "Dart Programming",
    slug: "/category/dartprogramming",
    path: "dartprogramming",
    image: "/category/Dart.jpg",
  },
  {
    id: 11,
    name: "Competitive Programming",
    slug: "/category/competitiveprogramming",
    path: "competitiveprogramming",
    image: "/category/Competitive Programming.jpg",
  },
  {
    id: 12,
    name: "Javascript Fundamentals",
    slug: "/category/javascriptfundamentals",
    path: "javascriptfundamentals",
    image: "/category/javaScriptfundamental.png",
  },
  {
    id: 13,
    name: "Python Fundamentals",
    slug: "/category/pythonfundamentals",
    path: "pythonfundamentals",
    image: "/category/python Fundamental.jpg",
  },
  {
    id: 14,
    name: "Programming AI & Data Science",
    slug: "/category/programming-aids",
    path: "programming-aids",
    image: "/category/Programming AI &  Data Science.jpg",
  },
  {
    id: 15,
    name: "Programming of Problem Solving",
    slug: "/category/problem-solving",
    path: "problem-solving",
    image: "/category/problem-solving-p.png",
    subcategories: [
      {
        id: 151,
        name: "ICPC",
        slug: "/category/problem-solving/icpc",
        path: "icpc",
        image: "/category/sub/icpc.png",
      },
      {
        id: 152,
        name: "Codechef",
        slug: "/category/problem-solving/codechef",
        path: "codechef",
        image: "/category/sub/Codechef.png",
      },
      {
        id: 153,
        name: "Leetcode",
        slug: "/category/problem-solving/leetcode",
        path: "leetcode",
        image: "/category/sub/Leetcode.png",
      },
      {
        id: 154,
        name: "HackerRank",
        slug: "/category/problem-solving/hackerrank",
        path: "hackerrank",
        image: "/category/sub/hackerrank-logo.jpg",
      },
      {
        id: 155,
        name: "Hackthon",
        slug: "/category/problem-solving/hackthon",
        path: "hackthon",
        image: "/category/sub/Hackathon.jpg",
      },
      {
        id: 156,
        name: "HackerRank Math",
        slug: "/category/problem-solving/hackerrank-math",
        path: "hackerrank-math",
        image: "/category/sub/HackerRank Math.jpg",
      },
      {
        id: 157,
        name: "Codeforces",
        slug: "/category/problem-solving/codeforces",
        path: "codeforces",
        image: "/category/sub/codeforces.png",
      },
      {
        id: 158,
        name: "GeeksforGeeks",
        slug: "/category/problem-solving/geeksforgeeks",
        path: "geeksforgeeks",
        image: "/category/sub/Geekforgeeks.jpg",
      },
    ],
  },
  {
    id: 16,
    name: "Mathematics AI/ML & Data Science",
    slug: "/category/mathematics-ai-ml-ds",
    path: "mathematics-ai-ml-ds",
    image: "/category/Mathematics AI ML & Data Science.jpg",
  },
  {
    id: 17,
    name: "Data Structures & Algorithms",
    slug: "/category/dsa",
    path: "dsa",
    image: "/category/data-structues-and-algorithms-mob.jpg",
  },
  {
    id: 18,
    name: "Cybersecurity",
    slug: "/category/cybersecurity",
    path: "cybersecurity",
    image: "/category/Cybersecurity.jpeg",
  },{
    id: 19,
    name: "Git & Github",
    slug: "/category/git-github",
    path: "git-github",
    image: "/category/git-github.png",
  },
];